// Module
import React from "react";
import { useSelector } from "react-redux";
import Router from "next/router";
// Material-UI
import { Box, CircularProgress, Typography } from "@mui/material";

// ==============================|| SPINNER ||============================== //

const Spinner = ({ fullScreen }) => {
    const [open, setOpen] = React.useState(false);
    const [routeChange, setRouteChange] = React.useState(false);
    const spinnerInitial = useSelector(state => state.spinner);

    React.useEffect(() => {
        const start = () => {
            setRouteChange(true);
        };
        const end = () => {
            setRouteChange(false);
        };
        Router.events.on("routeChangeStart", start);
        Router.events.on("routeChangeComplete", end);
        Router.events.on("routeChangeError", end);
        return () => {
            Router.events.off("routeChangeStart", start);
            Router.events.off("routeChangeComplete", end);
            Router.events.off("routeChangeError", end);
        };
    }, []);

    React.useEffect(() => {
        setOpen(spinnerInitial.loading.length > 0);
    }, [spinnerInitial.loading]);

    if (!open || routeChange || fullScreen !== spinnerInitial.fullScreen) {
        return null;
    }

    return (
        <Box
            sx={{
                alignItems: "center",
                backgroundColor: "rgba(32, 51, 78, 0.4)",
                borderRadius: "12px 12px 0px 0px",
                display: "flex",
                flexDirection: "column",
                inset: 0,
                justifyContent: "center",
                position: fullScreen && spinnerInitial.fullScreen ? "fixed" : "absolute",
                zIndex: 1400
            }}
        >
            <CircularProgress size={100} />
            {spinnerInitial.message && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "16px 0px"
                    }}
                >
                    <Typography variant="caption" component="div" color="textSecondary">
                        {spinnerInitial.message}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default Spinner;
